import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SERVICES_API } from '@loreal-doctors-video-platform/data';
import { Observable } from 'rxjs';
import { IConferencesSaveDto } from './models/conferences-save-dto';
import { environment } from 'apps/client/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConferencesService {
  constructor(
    @Inject(SERVICES_API)
    private readonly _servicesApi: string,
    private readonly _httpClient: HttpClient,
  ) {}

  /**
   * Get list of conferences
   */
  public fetchConferences(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${this._servicesApi}/public/conference/conferences`);
  }

  /**
   * Submit conference presence.
   * @param conferenceDto
   * @param recaptchaKey
   */
  public submit(conferenceDto: IConferencesSaveDto, recaptchaKey: string): Observable<void> {
    return this._httpClient.post<void>(
      `${environment.api}/public/conference/${conferenceDto.conferenceId}/submit`,
      {
        pzwNumber: conferenceDto.pwzNumber,
      },
      {
        params: {
          recaptchaKey,
        },
      },
    );
  }
}
